import { useQuery } from 'react-apollo';

import { AlbumFolderForFaceRecognitionDisabled } from '../../../graphql/queries/album-folder';

const useAlbumFolderForFaceRecognitionDisabled = ({ albumFolderId }) => {
  const { data: { albumFolder } = {}, loading } = useQuery(
    AlbumFolderForFaceRecognitionDisabled,
    {
      variables: {
        id: albumFolderId,
        include_roster_identity_data: false,
      },
      skip: !albumFolderId,
    },
  );

  return {
    albumFolder,
    loading,
  };
};

export default useAlbumFolderForFaceRecognitionDisabled;
